// src/components/ProjectCard.tsx
import React from "react";

interface ProjectCardProps {
  idx: number;
  title: string;
  description: string;
  image: string;
  techs: string[];
  link?: string;
}

export const ProjectCard: React.FC<ProjectCardProps> = ({
  idx,
  title,
  description,
  image,
  techs,
  link,
}) => {
  return (
    <div
      key={idx}
      className="flex flex-col sm:flex-row items-center bg-white rounded-lg shadow-lg p-4 gap-4 transition-transform transform hover:scale-105"
    >
      <div className="w-full sm:w-1/4 flex justify-center">
        <img src={image} alt={title} className="h-24 w-24 object-contain" />
      </div>

      <div className="w-full sm:w-2/3 flex flex-col justify-between">
        <h2 className="text-lg text-center md:text-left font-bold text-teal-700 mb-1">
          {title}
        </h2>
        <p className="text-gray-600 text-sm mb-4">{description}</p>

        <div className="flex flex-wrap gap-2 mb-4">
          {techs.map((tech, index) => (
            <span
              key={index}
              className="bg-teal-100 font-semibold text-teal-700 text-xs px-3 py-1 rounded-full"
            >
              {tech}
            </span>
          ))}
        </div>

        {link && (
          <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block font-semibold text-teal-500 text-xs hover:text-teal-700 duration-300 ease-in-out"
          >
            Ver proyecto
          </a>
        )}
      </div>
    </div>
  );
};
